/**
 * Перенос `lib/src/utils/extensions/file_extension.dart`.
 *
 * В Dart расширение висело на `dart:io File` и резало `file.path`. В вебе
 * запись микрофона — это `Blob`/`File`, у `File` есть готовое `name`, но оно
 * всё равно прогоняется через ту же чистку (разделители `/` и `\`), чтобы
 * поведение совпадало с Dart-версией.
 */

/** Имя без директорий: режем и по `/`, и по `\` — как в Dart-версии. */
function baseName(path: string): string {
  const afterSlash = path.split('/').pop() ?? '';
  return afterSlash.split('\\').pop() ?? '';
}

/** Возвращает имя файла без расширения */
export function fileNameWithoutExtension(file: File): string {
  const fileName = baseName(file.name);
  return fileName.split('.')[0];
}

/** Возвращает имя файла с расширением */
export function fileNameWithExtension(file: File): string {
  return baseName(file.name);
}

/** Возвращает только расширение файла (включая точку) */
export function fileExtension(file: File): string {
  const fileName = baseName(file.name);
  const parts = fileName.split('.');
  return parts.length > 1 ? `.${parts[parts.length - 1]}` : '';
}

/**
 * У `Blob` имени нет — MediaRecorder отдаёт просто данные. Если это всё-таки
 * `File`, берём его имя, иначе подставляем [fallback]: имя обязательно, оно
 * уходит в `multipart/form-data` как `filename`.
 */
export function blobFileName(blob: Blob, fallback: string): string {
  if (!(blob instanceof File)) return fallback;
  const name = baseName(blob.name);
  return name.length > 0 ? name : fallback;
}
